import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  selectScope,
  selectCategory,
  fetchMoviesIfNeeded,
  selectYear,
  fetchNewsIfNeeded,
  fetchMoviesFromFestivalIfNeeded,
  fetchCitiesIfNeeded,
  fetchMenusIfNeeded,
  fetchSectionsIfNeeded,
  selectSection,
  fetchMovies,
  selectMov2Filter,
  fetchPosterIfNeeded,
  fetchSponsorHomeIfNeeded,
  CLIENT_BASE_URL,
} from "../../actions";


import { Carousel, CarouselItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import CarouselImage from "./CarouselImage.jpg";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { ProgramView } from "../ProgramView/ProgramView";
import { MoviesView } from "../MoviesView/MoviesView";
import { SocialView } from "../SocialView/SocialView";
import { NewsView } from "../NewsView/NewsView";
import { SponsorView } from "../SponsorView/SponsorView";
import { SearchView } from "../SearchView/SearchView";


// We define mapStateToProps where we'd normally use
// the @connect decorator so the data requirements are clear upfront, but then
// export the decorated component after the main class definition so
// the component can be tested w/ and w/o being connected.
// See: http://rackt.github.io/redux/docs/recipes/WritingTests.html
const featuredImages = [CarouselImage];

export class HomeView extends React.Component {
  constructor(props) {
    super(props);

    this.gotoPage = this.gotoPage.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.getALLmovies = this.getALLmovies.bind(this);
    this.drawBackgroundImage = this.drawBackgroundImage.bind(this);
    this.renderBannerContainer = this.renderBannerContainer.bind(this);
    this.renderBannerLink = this.renderBannerLink.bind(this);
    this.onClickTagLabel = this.onClickTagLabel.bind(this);

    this.state = {
      successMsg: ""
    };
  }

  componentWillMount() {
    const { dispatch, selectedScope } = this.props;
    dispatch(fetchPosterIfNeeded(selectedScope));

    this.props.dispatch(selectScope("festa"));
    this.props.dispatch(selectCategory("0"));
    this.props.dispatch(selectYear("2019"));
    // this.props.dispatch(selectCity('1'))
  }

  componentDidMount() {
    const { dispatch, selectedCategory, selectedScope } = this.props;

    dispatch(fetchMenusIfNeeded(this.props.selectedScope));

    dispatch(fetchMoviesIfNeeded(selectedCategory, selectedScope));
    dispatch(fetchNewsIfNeeded(selectedScope));
    dispatch(fetchCitiesIfNeeded());
    // dispatch(fetchMoviesFromFestivalIfNeeded('1'))
    dispatch(fetchSectionsIfNeeded("movies"));
    dispatch(fetchSponsorHomeIfNeeded());

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  componentWillReceiveProps(nextProps) {
    const {
      dispatch,
      selectedCategory,
      selectedCity,
      selectedScope
    } = nextProps;

    if (nextProps.selectedCategory !== selectedCategory) {
      // dispatch(fetchMoviesIfNeeded(selectedCategory, selectedScope))
      // dispatch(fetchNewsIfNeeded(selectedScope))
      dispatch(fetchCitiesIfNeeded());
    }

    if (selectedScope !== this.props.selectedScope) {
      dispatch(selectMov2Filter("0", "FILMES"));
      dispatch(selectSection("SECÇÕES"));
      dispatch(fetchMovies(nextProps.selectedCategory, "festa"));
      dispatch(fetchMenusIfNeeded(selectedScope));
      dispatch(fetchPosterIfNeeded(selectedScope));
      dispatch(fetchNewsIfNeeded(selectedScope));
      // dispatch(fetchMoviesIfNeeded(selectedCategory, selectedScope))
    }

    // dispatch(selectSection('SECÇÕES'))

    if (nextProps.selectedCity !== selectedCity) {
      dispatch(fetchMoviesFromFestivalIfNeeded(selectedCity));
    }

    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  getFeaturedImage(pos) {
    return {
      backgroundImage: `url('${featuredImages[pos]}')`
    };
  }

  drawBackgroundImage(poster) {
    poster = CLIENT_BASE_URL + poster;
    return {
      backgroundImage: `url('${poster}')`
    };
  }

  renderCarrousel() {

    const { posters } = this.props;

    if (
      typeof posters === "undefined" ||
      !posters.hasOwnProperty("poster") ||
      typeof posters["poster"] === "undefined" ||
      !posters["poster"].length
    ) {

      return [];

    } else {

      return posters["poster"].map((info, i) => {
        return (
          <CarouselItem key={i}>
            {this.renderBannerLink(i, info)}
            <div key={`z${i}`} className="carousel-caption">
              <p dangerouslySetInnerHTML={{ __html: info.description }} />
            </div>
          </CarouselItem>
        );
      });
    }
  }

  renderBannerLink(i, info) {
    if (info.link === "") {
      return (
        <Link to="/">
          <div
            key={`k${i}`}
            className="carousel-img"
            style={this.drawBackgroundImage(info.img)}
          />
        </Link>
      );
    }

    let lnk = info.link;

    if (info.link.indexOf("festadocinemaitaliano.com/") !== -1) {
      lnk = info.link
        .replace("http://festadocinemaitaliano.com", "")
        .replace("http://www.festadocinemaitaliano.com", "")
        .replace("https://festadocinemaitaliano.com", "")
        .replace("https://www.festadocinemaitaliano.com", "");
      if (lnk === "") {
        lnk = "/";
      }
      return (
        <Link to={lnk}>
          <div
            key={`k${i}`}
            className="carousel-img"
            style={this.drawBackgroundImage(info.img)}
          />
        </Link>
      );
    }

    return (
      <a href={info.link} target="_blank">
        <div
          key={`k${i}`}
          className="carousel-img"
          style={this.drawBackgroundImage(info.img)}
        />
      </a>
    );
  }

  renderBanner() {
    const { posters } = this.props;

    return posters["banner"].map((info, i) => {
      return (
        <CarouselItem key={i}>
          {this.renderBannerLink(i, info)}
          <div key={`z${i}`} className="carousel-caption">
            <p dangerouslySetInnerHTML={{ __html: info.description }} />
          </div>
        </CarouselItem>
      );
    });
  }

  renderBannerContainer() {
    const { posters } = this.props;

    if (
      typeof posters === "undefined" ||
      !posters.hasOwnProperty("banner") ||
      typeof posters["banner"] === "undefined" ||
      !posters["banner"].length
    ) {
      return null;
    }

    return (
      <div className="banner-wrapper no-top-border row">
        <div className="col-lg-12">
          <Carousel interval={5000}>{this.renderBanner()}</Carousel>
        </div>
      </div>
    );
  }

  handleResize(e) {
    this.ww = window.innerWidth;
    this.wh = window.innerHeight;
    const h = this.wh - document.getElementById("main-hdr").clientHeight - 26;
    let carousel = document.querySelectorAll(".carousel");
    if (typeof carousel !== "undefined" && carousel.length) {
      carousel[0].style.height = h + "px";
    }
  }

  getALLmovies(movies, movieIds) {
    /*
    const movieIds = Object.keys(movies)

    return movieIds.map((id) => {
      return movies[id]
    })
    */

    if (!movieIds) {
      return [];
    }

    return movieIds.map(id => {
      return movies[id];
    });
  }

  onSearchChange(e) {
    // console.log('onSearchChange', e)
  }

  gotoPage(page) {
    this.props.history.push("/pesquisa");
  }

  onClickTagLabel(tagname) {
    this.props.dispatch(selectSection(tagname));
    this.props.history.push(`/filmes/${tagname}`);
  }

  render() {
    const {
      movies,
      isFetching,
      news,
      isFetchingNews,
      sections,
      sponsors,
      sponsorIds,
      selectedMov2Filter,
      movieIds
    } = this.props;
    const movies_2016 = this.getALLmovies(movies, movieIds);

    const {
      menus,
      dispatch,
      selectedSection,
      selectedAZ,
      selectedVisibility
    } = this.props;
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div className="row">
          <div className="col-lg-12 no-pad carousel-wrapper">
            <Carousel interval={3000}>{this.renderCarrousel()}</Carousel>
            <FooterLinks bottom_menus={bottom_menus} />
          </div>

          {selectedVisibility.festprog !== "0" ? (
            <ProgramView {...this.props} />
          ) : null}

          <SocialView
            customclass=""
            gotoPage={this.gotoPage}
            onChange={this.onSearchChange}
            dispatch={dispatch}
          >
            <SearchView
              gotoPage={this.gotoPage}
              onChange={this.onSearchChange}
              dispatch={dispatch}
            />
          </SocialView>
          {Object.keys(movies_2016).length &&
          selectedVisibility.movies !== "0" ? (
            <MoviesView
              className="top-red-border"
              movies_2016={movies_2016}
              isFetching={isFetching}
              dispatch={dispatch}
              scope="festa"
              onClickTagLabel={this.onClickTagLabel}
              selectedMov2Filter={selectedMov2Filter}
              sections={sections}
              selectedSection={selectedSection}
              selectedAZ={selectedAZ}
            />
          ) : null}

          {Object.keys(news).length && selectedVisibility.news !== "0" ? (
            <NewsView news={news} isFetchingNews={isFetchingNews} />
          ) : null}

          {this.renderBannerContainer()}
          <SponsorView
            key={"spon0"}
            sponsors={sponsors}
            sponsorIds={sponsorIds}
          />
        </div>
      </div>
    );
  }
}

HomeView.propTypes = {
  selectedCategory: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  movies: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  movieIds: PropTypes.array.isRequired,
  news: PropTypes.array.isRequired,
  isFetchingNews: PropTypes.bool.isRequired,
  selectedCity: PropTypes.string.isRequired,
  city_movies: PropTypes.object.isRequired,
  isFetchingMovieCity: PropTypes.bool.isRequired,
  cities: PropTypes.array.isRequired,
  isFetchingCities: PropTypes.bool.isRequired,
  selectedDay: PropTypes.string.isRequired,
  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  selectedSection: PropTypes.string.isRequired,
  selectedMov2Filter: PropTypes.object.isRequired,
  sections: PropTypes.array.isRequired,
  selectedAZ: PropTypes.number.isRequired,
  isFetchingPosters: PropTypes.bool.isRequired,
  posters: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  sponsors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  sponsorIds: PropTypes.array.isRequired,
  isFetchingSpHome: PropTypes.bool.isRequired,
  selectedScope: PropTypes.string.isRequired,
  selectedAgendaColor: PropTypes.string.isRequired,
  selectedVisibility: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const {
    selectedScope,
    selectedCategory,
    moviesByCategory,
    getAllnews,
    selectedCity,
    getMoviesFromFestival,
    getAllCities,
    selectedDay,
    getMenus,
    getSections,
    selectedSection,
    selectedAZ,
    getPosters,
    getSponsorHome,
    selectedMov2Filter,
    selectedAgendaColor,
    selectedVisibility,
    movieIds,
  } = state;

  const { isFetching, lastUpdated, items: movies } = moviesByCategory[
    selectedCategory
  ] || {
    isFetching: false,
    items: {}
  };

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingNews, lastUpdatedNews, items: news } = getAllnews[
    "all"
  ] || {
    isFetchingNews: true,
    items: []
  };

  const {
    isFetchingMovieCity,
    lastUpdatedCity,
    events: city_movies,
    numPastEvents
  } = getMoviesFromFestival[selectedCity] || {
    isFetchingMovieCity: true,
    events: {}
  };

  const { isFetchingCities, items: cities } = getAllCities["all"] || {
    isFetchingCities: true,
    items: []
  };

  const { isFetchingSections, items: sections } = getSections[
    `movies_${selectedScope}`
  ] || {
    isFetchingSections: true,
    items: []
  };

  const { isFetchingPosters, items: posters } = getPosters[selectedScope] || {
    isFetchingPosters: true,
    items: {}
  };

  const { isFetchingSpHome, items: sponsors, ids: sponsorIds } = getSponsorHome[
    "all"
  ] || {
    isFetchingSpHome: true,
    items: {},
    ids: []
  };


  return {
    selectedCategory,
    selectedAgendaColor,
    selectedVisibility,
    selectedDay,
    selectedMov2Filter,
    movies,
    movieIds,
    isFetching,
    lastUpdated,
    isFetchingNews,
    lastUpdatedNews,
    news,
    selectedCity,
    city_movies,
    isFetchingMovieCity,
    lastUpdatedCity,
    isFetchingCities,
    cities,
    isFetchingMenus,
    menus,
    lastUpdatedMenus,
    selectedSection,
    sections,
    isFetchingSections,
    selectedAZ,
    isFetchingPosters,
    posters,
    isFetchingSpHome,
    sponsors,
    sponsorIds,
    selectedScope,
    numPastEvents
  };
}

export default connect(mapStateToProps)(HomeView);



// WEBPACK FOOTER //
// ./src/views/HomeView/HomeView.js